var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboardCheck = function SvgClipboardCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "transparent",
    strokeWidth: 1.6,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.504 13.014 1.985 2.039a.48.48 0 0 0 .691 0l4.324-4.442m-.391-6.387h2.257c.9 0 1.63.75 1.63 1.674v13.428C19 20.25 18.27 21 17.37 21H6.63C5.73 21 5 20.25 5 19.326V5.898c0-.925.73-1.674 1.63-1.674h2.257m6.226 0v.795m0-.795v-.385m-6.226.385v.795m0-.795v-.385m6.226 1.18V3.84m0 1.18c-.002.423-.167.561-.458.86-.292.3-.686.469-1.098.471h-3.113a1.544 1.544 0 0 1-1.099-.47c-.291-.3-.456-.438-.458-.86m6.226-1.18c0-.925-.73-.838-1.63-.838h-2.966c-.9 0-1.63-.087-1.63.837m0 0v1.18"
  })));
};
export default SvgClipboardCheck;